import React from 'react';
import { Box, Typography, FormControl, FormControlLabel, Radio, RadioGroup, Button } from '@mui/material';

interface Question {
    idQuestion: string;
    type: string;
    question: string;
    A: string;
    B: string;
    C: string;
    D: string;
    E?: string;
    correct: string;
}

interface QuestionViewProps {
    question: Question;
    currentQuestionIndex: number;
    totalQuestions: number;
    answer: string;
    onChangeAnswer: (idQuestion: string, answer: string) => void;
    onPrev: () => void;
    onNext: () => void;
}

const QuestionView: React.FC<QuestionViewProps> = ({
    question, currentQuestionIndex, totalQuestions, answer, onChangeAnswer, onPrev, onNext
}) => (
    <Box sx={{ mt: 2 }}>
        <Typography variant="body1" sx={{ mb: 2, textAlign: 'left' }}>
            {question.question}
        </Typography>
        <FormControl component="fieldset">
            <RadioGroup
                name={question.idQuestion}
                value={answer || ''}
                onChange={(e) => onChangeAnswer(question.idQuestion, e.target.value)}
            >
                {['A', 'B', 'C', 'D', 'E'].map(
                    (option) =>
                        question[option as keyof Question] && (
                            <FormControlLabel
                                key={option}
                                value={option}
                                control={<Radio />}
                                label={question[option as keyof Question]}
                            />
                        )
                )}
            </RadioGroup>
        </FormControl>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button onClick={onPrev} disabled={currentQuestionIndex === 0}>
                Anterior
            </Button>
            <Button onClick={onNext} disabled={currentQuestionIndex === totalQuestions - 1}>
                Próxima
            </Button>
        </Box>
    </Box>
);

export default QuestionView;
